export const theme = {
  headerHeight: 50,
  headerColor: '#ff6a6a',
};
